<div class="card shadow mb-4 card-height">
  <div class="card-body">
    <div class="row">
      <!-- Tab Navigation -->
      <div class="col-2">
        <mat-list>
          <mat-list-item *ngFor="let tab of tabs">
            <button class="btn-block w-100 mb-2" color="primary" mat-raised-button *ngIf="selectedTab.value === tab.value">
              {{ tab.label }}
            </button>
            <button class="btn-block w-100 mb-2" color="primary" mat-stroked-button *ngIf="selectedTab.value !== tab.value"
                    (click)="selectTab(tab.value)">
              {{ tab.label }}
            </button>
          </mat-list-item>
        </mat-list>
      </div>
      <!-- Tab Contents -->
      <div class="col-10" [ngSwitch]="selectedTab.value" style="max-height: 600px; overflow: auto">
        <app-case-creditor-status-log *ngSwitchCase="'case_creditor_status_log'" [case]="case" [caseCreditorId]="caseCreditor?.id"></app-case-creditor-status-log>
        <app-case-notification-list *ngSwitchCase="'email_history'" [case]="case" [channel]="'email'" [caseCreditorId]="caseCreditor?.id" [emailHistoryType]="'case_creditor'"></app-case-notification-list>
        <app-case-notes *ngSwitchCase="'draft_notes'" noteType="draft" [case]="case" [caseCreditorId]="caseCreditor?.id" [draftNoteType]="'case_creditor'"></app-case-notes>
      </div>
    </div>
  </div>
</div>
